import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "./facultyData/cseAidsFacultyData";

export const programme = {
  id: "cse-aids",
  name: "Computer Science & Engineering(Data Science)",
  short: "CSE(Data Science)",
  programmeType: "ug",
  duration: "4 Years (8 Semesters)",
  intake: 60,
  studentsEnrolled: "To be updated",
  facultyStrength: "To be updated",
  phdFaculty: "To be updated",
  established: "To be updated",
  description:
    "The B.E. in Computer Science & Engineering (Artificial Intelligence & Data Science) is designed to build strong foundations in computer science, artificial intelligence, data analytics, machine learning, statistics, and intelligent data-driven systems. The programme prepares students to solve real-world problems through data modelling, computational thinking, software development, and emerging AI technologies.",
  image: "/HomePage/dept/ds.jpg",
  facultyData,
  labs: [
    "Programming Lab",
    "Data Science Lab",
    "Artificial Intelligence Lab",
    "Machine Learning Lab",
    "Database Systems Lab",
    "Project Lab",
  ],
  research:
    "Artificial Intelligence · Data Science · Machine Learning · Big Data Analytics · Intelligent Systems",
  // researchFundedProjects: 1,
  accreditation: ["AICTE Approved", "VTU Affiliated", "Programme details to be updated"],
  projects: [
    { title: "AI and Data Science Student Projects", funding: "Department activity", amount: "To be updated" },
  ],
  dashboard: [
    ["Duration", "4 Years"],
    ["Intake", "60"],
    ["Degree", "B.E."],
    ["Affiliation", "VTU"],
  ],
  academicOverview: [
    {
      title: "AI and Data-Centric Learning",
      text: "The programme combines core computer science with artificial intelligence, data science, analytics, and applied machine learning for industry-focused problem solving.",
    },
    {
      title: "Practical Skill Development",
      text: "Students gain hands-on exposure through programming, datasets, laboratory work, mini-projects, internships, and capstone projects.",
    },
    {
      title: "Career-Oriented Foundation",
      text: "The curriculum supports career pathways in software development, AI engineering, data analytics, data engineering, business intelligence, and research.",
    },
  ],
  curriculumSupport: [
    "Programming and problem-solving practice from the first year.",
    "Hands-on work with datasets, analytics tools, and AI/ML models.",
    "Mini-projects and capstone projects based on real-world problems.",
    "Industry interactions, workshops, internships, and certification opportunities.",
    "Soft skills and employability training for professional readiness.",
  ],
  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
  pso: [
    "Apply artificial intelligence and data science techniques to analyze, model, and solve real-world problems.",
    "Design and develop data-driven software systems using modern computing tools and technologies.",
  ],
  peo: [
    "Build successful careers in computer science, artificial intelligence, data science, software development, and allied domains.",
    "Pursue higher education, research, innovation, entrepreneurship, and professional growth.",
    "Practice engineering with ethical responsibility, teamwork, communication, and lifelong learning.",
  ],
};

const CSEAIDS = () => <ProgrammeDetail programme={programme} />;

export default CSEAIDS;
